const itemsPath = '/items';
export default itemsPath;
